/**
 * Realizations Gallery Swiper
 * Karuzela galerii realizacji w single-offer
 */

(function() {
    'use strict';

    function initRealizationsSwiper() {
        const swiperElement = document.querySelector('[data-realizations-swiper]');
        
        if (!swiperElement || typeof window.Swiper === 'undefined') {
            return;
        }

        const swiper = new window.Swiper(swiperElement, {
            modules: [window.SwiperNavigation, window.SwiperPagination],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            grabCursor: true,
            preventClicks: false,
            preventClicksPropagation: false,
            
            // Responsive breakpoints
            breakpoints: {
                // Mobile
                576: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                // Tablet
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                // Desktop
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            },
            
            // Navigation arrows
            navigation: {
                nextEl: '.realizations-swiper-next',
                prevEl: '.realizations-swiper-prev',
            },
            
            // Pagination
            pagination: {
                el: '.realizations-swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },
        });
        
        // Inicjalizuj Viewer.js PO inicjalizacji Swipera
        setTimeout(() => {
            const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
            if (swiperWrapper && typeof window.Viewer === 'function') {
                new window.Viewer(swiperWrapper, {
                    title: false,
                    navbar: true,
                    toolbar: true,
                    url: 'data-src',
                });
                console.log('Viewer.js zainicjalizowany dla realizacji swiper');
            }
        }, 100);
    }

    // Init po załadowaniu DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRealizationsSwiper);
    } else {
        initRealizationsSwiper();
    }

})();
